import { useTranslation } from "react-i18next";
import { changeLanguage } from "../../../../components/helper";
import { topImage } from "../../../../components/imageLoader";

export default function TopContext() {

    const { t, i18n } = useTranslation()
    let direction = i18n.dir()
    return (
        <div className='d-flex flex-row justify-content-between head-tools-context' >
            <a href='https://dartamas.com/' className='text-decoration-none'>
                <button className='btn btn-default main-page-btn' type="button"
                >{t('MAIN.PAGE_SITE')}</button>

            </a>
            <div className='d-flex flex-column justify-content-start' >
                <div className='d-flex flex-row justify-content-end'>
                    <button className='btn btn-default main-page-btn' style={{ width: '40px' }} onClick={() => changeLanguage(i18n, direction)} >{direction === 'ltr' ? 'فا' : 'En'}</button>
                </div>
                <img className="top-image" src={topImage} alt="" />
            </div>
        </div>
    )
}
